import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { ApiEndpointHandler, createPostEndpoint } from '@sonar-software/sonar-http';

export type PostDataDictionaryExportStartRequest = {
	applicationId: number | undefined;
	complianceCategory: number | undefined;
	filters?: string;
	sonarObjectId: number | undefined;
	sonarObjectType: SonarObjectType | undefined;
	sortBy: string;
	sortDirection: 'Ascending' | 'Decending';
	tagId: number | undefined;
};

export type PostDataDictionaryExportStartResponse = { id: number };

const postDataDictionaryFieldsExportStart = createPostEndpoint<
	PostDataDictionaryExportStartRequest,
	PostDataDictionaryExportStartResponse
>((request) => `/api/v3/core/exports/fields/${request.sonarObjectId}/export/start`);

const postDataDictionaryTypesExportStart = createPostEndpoint<
	PostDataDictionaryExportStartRequest,
	PostDataDictionaryExportStartResponse
>((request) => `/api/v3/core/exports/sonar-object/types/${request.sonarObjectType}/export/start`);

const postDataDictionaryApplicationsExportStart = createPostEndpoint<
	PostDataDictionaryExportStartRequest,
	PostDataDictionaryExportStartResponse
>((request) => `/api/v3/core/exports/applications/${request.applicationId}/export/start`);

const postDataDictionaryTagsExportStart = createPostEndpoint<
	PostDataDictionaryExportStartRequest,
	PostDataDictionaryExportStartResponse
>((request) => `/api/v3/core/exports/datadictionary/tags/${request.tagId}/export/start`);

const postDataDictionaryComplianceCategoriesExportStart = createPostEndpoint<
	PostDataDictionaryExportStartRequest,
	PostDataDictionaryExportStartResponse
>((request) =>
	`/api/v3/core/exports/datadictionary/compliance-categories/${request.complianceCategory}/export/start`);

export const postDataDictionaryExportStart: ApiEndpointHandler<
	PostDataDictionaryExportStartRequest,
	PostDataDictionaryExportStartResponse
> = (request) => {
	if (request.sonarObjectId) {
		return postDataDictionaryFieldsExportStart(request);
	} else if (request.sonarObjectType) {
		return postDataDictionaryTypesExportStart(request);
	} else if (request.applicationId) {
		return postDataDictionaryApplicationsExportStart(request);
	} else if (typeof request.complianceCategory === 'number') {
		return postDataDictionaryComplianceCategoriesExportStart(request);
	}

	return postDataDictionaryTagsExportStart(request);
};
